export const isLocalLink = (url = "") => url.startsWith("/");
export default isLocalLink;
